const paths = {
  backlog: '/jobs/backlog',
  import: '/jobs/import',
  board: '/jobs/board',
  monitor: '/jobs/monitor',
  report: '/jobs/report',
  workingActivityReport: '/jobs/workingActivityReport',
  turno : '/jobs/shift',
  bulkUserManagement: '/jobs/settings'
};

export default paths;
